/* BreadcrumbRenderer.js */

'use strict';
const _ = require('lodash');

class BreadcrumbsRenderer {
  constructor(model) {
    this._model = model;
    this._rootElem = document.createElement('game-editor-breadcrumb-gl');
    this._rootElem.component = this._model;
    this._breadcrumbElems = [];
    this._registerListeners();
  }
  /********************************************/
  /* START PRIVATE COMPONENT RENDERER METHODS */
  /********************************************/
  _shutdown() {
    let prom = new Promise((resolve /*,reject*/) => {
      this._unregisterListeners();
      this._breadcrumbElems = undefined;
      this._model = undefined;
      this._rootElem.remove();
      this._rootElem = undefined;
      resolve();
    });
    return prom;
  }
  _registerListeners() {
    this._model.on(
      'BreadcrumbChanged',
      (this._onBreadcrumbsChanged = this._onBreadcrumbsChanged.bind(this))
    );
  }
  _unregisterListeners() {
    this._model.removeListener('BreadcrumbChanged', this._onBreadcrumbsChanged);
  }
  /*******************************************/
  /* END PRIVATE COMPONENT RENDERER METHODS  */
  /* START PUBLIC COMPONENT RENDERER METHODS */
  /*******************************************/
  /**
   * Stateless method to completely rebuild this component from the _rootElem down.
   * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
   * Promise is returned the caller will assume the Renderer has completed rendering.
   */
  render() {
    this._breadcrumbElems = [];
    this._rootElem.innerHTML = '';
    this._renderBreadcrumbs();
    return Promise.resolve();
  }
  get rootElement() {
    return this.getRootElement();
  }
  getRootElement() {
    return this._rootElem;
  }
  get model() {
    return this.getModel();
  }
  getModel() {
    return this._model;
  }
  /*******************************************/
  /* END COMPONENT RENDERER METHODS */
  /* START PRIVATE RENDER METHODS */
  /*******************************************/
  _renderBreadcrumbs() {
    let breadCrumbsInfo = this._model.getBreadcrumbs();
    breadCrumbsInfo.forEach((bcInfo) => {
      let breadCrumbElements = {
        value: _.get(bcInfo, 'value'),
      };
      breadCrumbElements.breadcrumbElem = document.createElement('breadcrumb-gl');
      if (_.get(bcInfo, 'notClickable')) {
        breadCrumbElements.breadcrumbElem.classList.add('not_clickable');
      }
      //If we are rendering something on the left side of this breadcrumb
      if (_.get(bcInfo, 'left')) {
        if (_.get(bcInfo.left, 'arrow')) {
          let arrowDirection = _.get(bcInfo.left.arrow, 'direction', 'right');
          breadCrumbElements.leftArrowElem = document.createElement('base-icon-gl');
          breadCrumbElements.leftArrowElem.dataset.icon = 'common.back';
          breadCrumbElements.leftArrowElem.setAttribute('data-dark-theme', 'true');
          breadCrumbElements.leftArrowElem.dataset.direction = arrowDirection;
          let isActive = _.get(bcInfo.left.arrow, 'active', false);
          if (isActive) {
            breadCrumbElements.leftArrowElem.active = true;
          }
          if (!_.get(bcInfo.left.arrow, 'notClickable')) {
            breadCrumbElements.leftArrowElem.addEventListener('click', () => {
              this._model.onLeftArrowClicked(bcInfo);
            });
          } else {
            //breadCrumbElements.leftArrowElem.makeSimple()
          }
          breadCrumbElements.breadcrumbElem.appendChild(breadCrumbElements.leftArrowElem);
        }
      }
      //If we are rendering content for this breadcrumb
      let content = _.get(bcInfo, 'content');
      if (content) {
        breadCrumbElements.contentElem = document.createElement('breadcrumb-content-gl');
        //Normal dom String
        if (_.isString(content) || content instanceof HTMLElement) {
          breadCrumbElements.contentElem.classList.add('raw_content');
          breadCrumbElements.contentElem.innerHTML = content;
          if (!_.get(bcInfo, 'notClickable')) {
            breadCrumbElements.contentElem.addEventListener('mouseup', (/*evt*/) => {
              this._model.onContentClicked(bcInfo);
            });
          }
        }
        //If its a component
        else if (_.isObject(content)) {
          let cmpnt = new content(bcInfo); //jshint ignore:line
          breadCrumbElements.contentElem.classList.add('component_content');
          breadCrumbElements.contentElem.appendChild(cmpnt.renderer.rootElement);
        }
        breadCrumbElements.breadcrumbElem.appendChild(breadCrumbElements.contentElem);
      }
      //If we are rendering something on the right side of this breadcrumb
      if (_.get(bcInfo, 'right')) {
        if (_.get(bcInfo.right, 'arrow')) {
          let arrowDirection = _.get(bcInfo.right.arrow, 'direction', 'right');
          if (arrowDirection) {
            breadCrumbElements.rightArrowElem = document.createElement('base-icon-gl');
            breadCrumbElements.rightArrowElem.dataset.icon = 'common.back';
            breadCrumbElements.rightArrowElem.setAttribute('data-dark-theme', 'true');
            breadCrumbElements.rightArrowElem.dataset.direction = arrowDirection;
            let isActive = _.get(bcInfo.left.arrow, 'active', false);
            if (isActive) {
              breadCrumbElements.rightArrowElem.active = true;
            }
            if (!_.get(bcInfo, 'notClickable')) {
              breadCrumbElements.rightArrowElem.addEventListener('click', () => {
                this._model.onRightArrowClicked(bcInfo);
              });
            } else {
              //breadCrumbElements.rightArrowElem.makeSimple()
            }
            breadCrumbElements.breadcrumbElem.appendChild(breadCrumbElements.rightArrowElem);
          }
        }
      }
      this._rootElem.appendChild(breadCrumbElements.breadcrumbElem);
      this._breadcrumbElems.push(breadCrumbElements);
    });
  }
  /*******************************************/
  /* END PRIVATE RENDER METHODS */
  /* START HANDLER METHODS */
  /*******************************************/
  _onBreadcrumbsChanged() {
    this.render();
  }
  /*******************************************/
  /* END HANDLER METHODS */
  /* START PRIVATE API METHODS */
  /*******************************************/

  /*******************************************/
  /*  END PRIVATE API METHODS */
  /*******************************************/
}
module.exports = BreadcrumbsRenderer;
